const fuseSettingsConfig = {
    layout          : {
        navbar      : 'left', // 'right', 'left', 'top', 'none'
        navbarFolded: false, // true, false
        toolbar     : 'above', // 'above', 'below', 'none'
        footer      : 'below', // 'above', 'below', 'none'
        mode        : 'fullwidth' // 'boxed', 'fullwidth'
    },
    customScrollbars: true,
    theme           : 'default',
    navbarTheme     : 'currentThemeDark',
    toolbarTheme    : 'default',
    footerTheme     : 'currentThemeDark'
};

export default fuseSettingsConfig;